import React from 'react';
import { toast } from 'react-toastify';
import api from '../api';
import Pagination from '@material-ui/lab/Pagination';


class ActionComponent extends React.Component {
   
    constructor(props) {
        super(props)
        this.state = {
            apiUrl: '',
            data: [],
            apiLoading: true,
            error:'',
            pagina:1,
            mostrarErroToast:false
        };

        this.buscar = this.buscar.bind(this);
        this.callbackSucesso = this.callbackSucesso.bind(this)
    }

    //metodo para buscar 
    buscar (){

        const { apiUrl, pagina }  = this.state;


        if(apiUrl){
            api.get(`${apiUrl}?page=${pagina}`)
                .then(res => {
                    this.setState({data:res.data})
                    this.callbackSucesso(res.data);
                })
                .catch((error) => {
                    // toast.success(<h6>Produto cadastrado</h6>)
                    console.log(error)
            });
            this.setState({ apiLoading:false })
        }
	}

    //metodo para sobrescrever
    callbackSucesso(data){

    }

    handlePaginacao(event, value){
        this.setState({pagina:value}, () => this.buscar());
    };

    renderPaginacao(){
        if(this.state.data?.data){
            if(this.state.data.total > this.state.data.limit){
                return(
                    <div className="py-2" style={{display: 'flex', justifyContent: 'center'}}>
                        <Pagination color="secondary"  variant="outlined"  showFirstButton showLastButton  count={Math.ceil(this.state.data.total/ this.state.data.limit)} page={this.state.pagina} onChange={(event, value)=> this.handlePaginacao(event, value)} />
                    </div>
                )
            }
        }
    }

}

export default ActionComponent;